import { render, staticRenderFns } from "./RedditiTable.vue?vue&type=template&id=edced034&"
import script from "./RedditiTable.vue?vue&type=script&lang=js&"
export * from "./RedditiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RedditiTable.vue"
export default component.exports